import React from 'react';
import PropTypes from 'prop-types';
import {Constantes} from '@common/utils';

export const IncidentsSummary = ({ incidents }) => {
  const storesWithIncidents = incidents.filter(
    (inc) => inc.statusId === Constantes.INCIDENT_STATUS_ID.OPEN, 
  ).length;
  
  const completedIncidents = incidents.filter(
    (inc) => inc.statusId === Constantes.INCIDENT_STATUS_ID.CLOSED, 
  ).length;

  const CounterItem = ({ count, label }) => (
    <div className="incidents-summary__item">
      <div className="incidents-summary__count">{count}</div>
      <div className="incidents-summary__label">{label}</div>
    </div>
  );

  return (
    <div className="incidents-summary">
      <CounterItem 
        count={storesWithIncidents} 
        label="Reportadas con incidentes" 
      />
      <CounterItem 
        count={completedIncidents} 
        label="Incidentes resueltos" 
      />
    </div>
  );
};

IncidentsSummary.propTypes = {
  incidents: PropTypes.arrayOf(
    PropTypes.shape({
      statusId: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default IncidentsSummary;